<script setup>
import { reviewItems, reviewDisclaimer } from '../../config/pageData.js';
</script>

<template>
  <section class="m-sec">
    <h2 class="m-title">學員真實反饋</h2>
    <p class="m-sub">嚟自「中華智慧大講堂」課堂群組嘅真實截圖。</p>
    <div class="m-reviews">
      <div
        v-for="(item, i) in reviewItems"
        :key="i"
        class="m-review"
      >
        <img
          :src="item.image"
          alt="學員反饋"
          class="m-review-img"
          loading="lazy"
        />
        <div class="m-review-cap">{{ item.cap }}</div>
      </div>
    </div>
    <p class="m-review-disclaimer">{{ reviewDisclaimer }}</p>
  </section>
</template>

<style scoped lang="scss">
.m-sec {
  padding: 96px 32px;
}

.m-title {
  font-size: 44px;
  font-weight: 700;
  line-height: 1.4;
  text-align: center;
  color: #16241d;
  letter-spacing: 1px;
}

.m-sub {
  text-align: center;
  color: #6f6a5c;
  font-size: 26px;
  margin-top: 18px;
}

.m-reviews {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 22px;
  margin-top: 44px;
  align-items: start;
}

.m-review {
  background: #fff;
  border: 1px solid #e7dfcc;
  border-radius: 18px;
  padding: 16px;
  box-shadow: 0 8px 22px rgba(22, 36, 29, 0.08);
}

.m-review-img {
  width: 100%;
  border-radius: 12px;
  display: block;
}

.m-review-cap {
  text-align: center;
  font-size: 24px;
  color: #6f6a5c;
  padding: 10px 4px 6px;
}

.m-review-disclaimer {
  margin-top: 24px;
  text-align: center;
  font-size: 22px;
  color: #6f6a5c;
}
</style>
